<div class="additional-resources hidden">
  <h1 class="ui-heading-1-bold additional-resources-title">
    {{ knowledgeSection() }}
  </h1>

  <ul class="additional-resources-content">
    @for(a of additionalResources(); track $index) {
      @if(a.published === true) {
      <li class="additional-resource-item">
        <a rds-link standalone href="{{ a.url }}" target="_blank">
          {{ a.title }}
          <rds-icon namespace="filled" icon="arrow_right" />
        </a>
      </li>
      }
    }
  </ul>
</div>
